import { Button, Form, Input, message } from "antd";
import { layoutForms, toEnglishDigits } from "../../../component/utility";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";

const RegisterStudent = (props) => {
  const [form] = Form.useForm();

  const _onFinishForm = async (values) => {
    console.log(values);

    values.studentCode = toEnglishDigits(values.studentCode);
    values.mobile = toEnglishDigits(values.mobile);

    let url = Url.RegisterStudent;

    let res = await props.actions.CallCoreServicesActionWithToken(url, values);

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    form.resetFields();
    message.success("با موفقیت ثبت شد");
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Form
          {...layoutForms}
          form={form}
          name="register"
          onFinish={_onFinishForm}
        >
          <Form.Item
            name="studentCode"
            label="شماره دانشجویی"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="name"
            label="نام"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="mobile" label="موبایل">
            <Input />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button onClick={() => form.submit()}>ثبت دانشجو</Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStudent);
